import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import { notNull } from '~/_shared/utils/typeGuards';
import type { AppState } from '~/store/app.store';
import {
  type Chart, type ChartMetric, type ChartWithRefMetrics,
  isChartMetricSpreadsheetColumnRef,
} from './mapSettingsCharts.types';

const mapSettingsChartsItemsSelector = (state: AppState) => state.map.mapSettings.data.charts.items;
const mapSettingsChartsColumnsMapSelector = (state: AppState) => state.map.mapSettings.data.charts.columnsMap;

export const mapSettingsChartsSelector = createStateSelector([
  mapSettingsChartsItemsSelector,
  mapSettingsChartsColumnsMapSelector,
], (items, columnsMap) => {
  const resolveRefColumnsInMetrics = (items: ChartWithRefMetrics['metrics']): ReadonlyArray<ChartMetric> =>
    items.map(metric => {
      if (isChartMetricSpreadsheetColumnRef(metric)) {
        const spreadsheetColumnId = columnsMap[metric.column];
        if (spreadsheetColumnId) {
          return {
            ...metric,
            column: spreadsheetColumnId,
          } satisfies ChartMetric;
        }
        return null;
      }
      return metric;
    }).filter(notNull);

  return items.map(chart => ({
    ...chart,
    metrics: resolveRefColumnsInMetrics(chart.metrics),
  } as Chart));
});

export const useMapSettingsChartsSelector = () => useSelector(mapSettingsChartsSelector);
